import axios from "axios"

const Api = axios.create({
  baseURL: 'https://run.mocky.io/v3/cc24296f-95d4-4a96-8624-55cfcf7ee012',
});


export default Api

